import { useEffect, useState } from "react"
import FiltrosRelatorioMetas from "../../components/FiltrosRelatorioMetas/FiltrosRelatorioMetas"
import TabelaRelatorioMetas from "../../components/TabelaRelatorioMetas/TabelaRelatorioMetas"

export default function RelatorioMetas() {
    //Config
    const max = 20;
    
    //Data
    const [ metas, setMetas ] = useState(undefined);
    const [ animais, setAnimais ] = useState([]);

    //Utils
    const [ filtros, setFiltros ] = useState({});
    const [ page, setPage ] = useState(1);
    const [ numberOfPages, setNumberOfPages ] = useState(1);
    const [ isLoaded, setLoad ] = useState(false);
    
    function resetPage() {
        setPage(1)
    }

    return <>
        <FiltrosRelatorioMetas
            setMetas={setMetas}
            setAnimais={setAnimais}
            setFiltros={setFiltros}
            setLoad={setLoad} 
            resetPage={resetPage}
            setNumberOfPages={setNumberOfPages}
            max={max}
        />
        <TabelaRelatorioMetas 
            metas={metas}
            setMetas={setMetas}
            animais={animais}
            filtros={filtros}
            isLoaded={isLoaded}
            page={page}
            setPage={setPage}
            numberOfPages={numberOfPages}
            max={max}
        />
    </>
}